import React, { useState, useEffect } from 'react';

export default function PerfilNeuroterapeuta({ token, usuario, onUpdate }) {
  const [form, setForm] = useState({
    nombre: usuario.nombre || '',
    email: usuario.email || '',
    telefono: usuario.telefono || '',
    especialidad: usuario.especialidad || '',
    avatar: null
  });
  const [preview, setPreview] = useState(usuario.avatar ? usuario.avatar : null);
  const [error, setError] = useState('');
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordForm, setPasswordForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [passwordError, setPasswordError] = useState('');
  const [passwordOk, setPasswordOk] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);

  useEffect(() => {
    setForm({
      nombre: usuario.nombre || '',
      email: usuario.email || '',
      telefono: usuario.telefono || '',
      especialidad: usuario.especialidad || '',
      avatar: null
    });
    setPreview(usuario.avatar ? usuario.avatar : null);
  }, [usuario]);

  const handleChange = e => {
    const { name, value, files } = e.target;
    if (name === 'avatar') {
      setForm(f => ({ ...f, avatar: files[0] }));
      setPreview(files[0] ? URL.createObjectURL(files[0]) : usuario.avatar || null);
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setOk(false);
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('nombre', form.nombre);
      fd.append('telefono', form.telefono);
      fd.append('especialidad', form.especialidad);
      if (form.avatar) fd.append('avatar', form.avatar);
      // El email normalmente no se edita, pero si quieres permitirlo, descomenta:
      // fd.append('email', form.email);
  const res = await fetch(`https://api.braineka.com/usuarios/${usuario.id}`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}` },
        body: fd
      });
      if (!res.ok) throw new Error('No se pudo actualizar el perfil');
      setOk(true);
      if (onUpdate) onUpdate();
    } catch (e) {
      setError('Error actualizando perfil');
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = e => {
    const { name, value } = e.target;
    setPasswordForm(current => ({ ...current, [name]: value }));
  };

  const handlePasswordSubmit = async e => {
    e.preventDefault();
    setPasswordError('');
    setPasswordOk(false);

    if (passwordForm.newPassword.length < 8) {
      setPasswordError('La nueva contraseña debe tener al menos 8 caracteres.');
      return;
    }

    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setPasswordError('La nueva contraseña y su confirmación no coinciden.');
      return;
    }

    setPasswordLoading(true);
    try {
      const res = await fetch('https://api.braineka.com/usuarios/me/password', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          currentPassword: passwordForm.currentPassword,
          newPassword: passwordForm.newPassword
        })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'No se pudo actualizar la contraseña');
      setPasswordOk(true);
      setPasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (e) {
      setPasswordError(e.message || 'No se pudo actualizar la contraseña');
    } finally {
      setPasswordLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '0 auto' }}>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <h2>Mi Perfil</h2>
        <input name="nombre" placeholder="Nombre" value={form.nombre} onChange={handleChange} required />
        <input name="telefono" placeholder="Teléfono" value={form.telefono} onChange={handleChange} />
        <textarea name="especialidad" placeholder="Especialidad, Bio o CV" value={form.especialidad} onChange={handleChange} rows={3} />
        <label>Foto (opcional): <input name="avatar" type="file" accept="image/*" onChange={handleChange} /></label>
        {preview && <div><img src={preview} alt="avatar" style={{ maxWidth: 120, margin: 8 }} /></div>}
        <button type="submit" disabled={loading}>{loading ? 'Guardando...' : 'Guardar cambios'}</button>
        {error && <div style={{ color: 'red' }}>{error}</div>}
        {ok && <div style={{ color: 'green' }}>Perfil actualizado correctamente.</div>}
      </form>

      <form onSubmit={handlePasswordSubmit} style={{ marginTop: 24 }}>
        <h3>Cambiar contraseña</h3>
        <input
          name="currentPassword"
          type="password"
          placeholder="Contraseña actual"
          value={passwordForm.currentPassword}
          onChange={handlePasswordChange}
          required
        />
        <input
          name="newPassword"
          type="password"
          placeholder="Nueva contraseña"
          value={passwordForm.newPassword}
          onChange={handlePasswordChange}
          minLength={8}
          required
        />
        <input
          name="confirmPassword"
          type="password"
          placeholder="Repetir nueva contraseña"
          value={passwordForm.confirmPassword}
          onChange={handlePasswordChange}
          minLength={8}
          required
        />
        <button type="submit" disabled={passwordLoading}>
          {passwordLoading ? 'Actualizando...' : 'Actualizar contraseña'}
        </button>
        {passwordError && <div style={{ color: 'red' }}>{passwordError}</div>}
        {passwordOk && <div style={{ color: 'green' }}>Contraseña actualizada correctamente.</div>}
      </form>
    </div>
  );
}
